import React from "react";
import MUIDataTable from "mui-datatables";
import "./MuiTable.css";

// import "bootstrap/dist/css/bootstrap.min.css";
const MuiTable = ({ columns, data }) => {
  const options = {
    filterType: "checkbox",
    // tableBodyHeight: "calc(100vh - 245px)",
    pagination: false,
    search: false,
    print: false,
    download: false,
    viewColumns: false,
    sortFilterList: false,
    filter: false,
    selectableRowsHeader: false,
    fixedHeader: false,
    responsive: "standard",
    rowsPerPage: 10,
    sort: true,
    rowHover: false,
    selectToolbarPlacement: "none",
  };
  return <MUIDataTable data={data} columns={columns} options={options} />;
};

export default MuiTable;
